export default __webpack_public_path__ + "static/media/1_0132.1df51c57.webp";